import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";
let sort = class sort extends Vue {
  constructor() {
    super(...arguments);
    this.answer = [];
  }
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer.map(as => {
          return as.id;
        });
        let optionsList = [];
        value.answer.forEach(oas => {
          let findop = this.item.optionsList.find(op => {
            return oas.id == op.id;
          });
          if (findop) {
            findop.otherInputAnswer = oas.content;
            optionsList.push(findop);
          }
        });
        let otherOps = this.item.optionsList.filter(op => {
          return !this.answer.includes(op.id);
        });
        optionsList.push(...otherOps);
        this.item.optionsList = optionsList;
      }
    }
  }
  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
  get ruleDesc() {
    return "";
    /*  if (!this.data.jsonConfig) return "";
    const { selectRangeMin, selectRangeMax } = this.data.jsonConfig;
    const res: any = [];
    console.log("selectRangeMin, selectRangeMax", JSON.stringify(this.data.jsonConfig), selectRangeMin, selectRangeMax);
    // （最少选3项，最多选5项）
    if (selectRangeMin) {
      res.push(`最少选${selectRangeMin}项`);
    }
    if (selectRangeMax) {
      res.push(`最多选${selectRangeMax}项`);
    }
    if (res.length) {
      return `（${res.join("，")}）`;
    }*/
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], sort.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], sort.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], sort.prototype, "showScore", void 0);
__decorate([Prop({
  type: String,
  default: ""
})], sort.prototype, "businessType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], sort.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], sort.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], sort.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], sort.prototype, "dataChage", null);
sort = __decorate([Component({
  name: "sort"
})], sort);
export default sort;